var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSentinelOne = function SvgSentinelOne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4500b6",
    d: "m10 4.1 9.5 4v-4L10 0ZM10 15.9l9.5-4v4L10 20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6100ff",
    d: "m10 4.1-9.5 4v-4L10 0ZM10 15.9l-9.5-4v4L10 20ZM2.5 9.1l10 5 4.6-2.4-10-5Z"
  })));
};
export default SvgSentinelOne;